import { render, staticRenderFns } from "./team-members-contact-card.vue?vue&type=template&id=0c3915da"
import script from "./team-members-contact-card.vue?vue&type=script&lang=js"
export * from "./team-members-contact-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports